<form #itemForm="ngForm" name="itemForm" id="itemForm" [class.edit-modal]="!this.isHumEdit"
  [class.kw-dialog]="!this.isHumEdit">

  <!-- Inline in Create Inventory -->
  <nb-card *ngIf="this.isHumEdit; else dialogView" class="form-section-card">
    <nb-card-body [nbSpinner]="this.isLoading">
      <div class="section-head">
        <fa-icon [icon]="faPlusCircle" class="section-icon"></fa-icon>
        <h3>Add Item</h3>
        <ng-container *ngTemplateOutlet="newButtons"></ng-container>
      </div>
      <div class="field-stack">
        <ng-container *ngTemplateOutlet="productField"></ng-container>
        <ng-container *ngTemplateOutlet="lotField"></ng-container>
        <ng-container *ngTemplateOutlet="qtyFields"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="qtySummary"></ng-container>
      <div class="text-end mt-3">
        <button mat-stroked-button type="submit" [disabled]="!this.canAdd" (click)="addItemToHum()">
          <fa-icon [icon]="faPlus" class="me-2"></fa-icon>Add to Unit
        </button>
      </div>
    </nb-card-body>
  </nb-card>

  <ng-template #dialogView>
    <div class="modal-header">
      <div>
        <h2 class="modal-title">Add {{"Product" | tenantWords}}</h2>
        <div class="modal-subtitle">{{this.subtitle}}</div>
      </div>
      <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close()">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>

    <div class="modal-body" [nbSpinner]="this.isLoading">
      <section class="form-section">
        <div class="section-head">
          <fa-icon [icon]="faCubes" class="section-icon"></fa-icon>
          <h3>{{"Product" | tenantWords}}</h3>
          <ng-container *ngTemplateOutlet="newButtons"></ng-container>
        </div>
        <div class="section-grid">
          <ng-container *ngTemplateOutlet="productField"></ng-container>
          <ng-container *ngTemplateOutlet="lotField"></ng-container>
        </div>
      </section>

      <section class="form-section">
        <div class="section-head">
          <fa-icon [icon]="faSliders" class="section-icon"></fa-icon>
          <h3>Quantity</h3>
        </div>
        <div class="section-grid cols-3">
          <ng-container *ngTemplateOutlet="qtyFields"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="qtySummary"></ng-container>
      </section>
    </div>

    <div class="modal-footer">
      <button mat-stroked-button type="button" (click)="close()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="!this.canAdd" (click)="submit()">
        <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
      </button>
    </div>
  </ng-template>

  <ng-template #newButtons>
    <div class="section-actions">
      <button mat-button color="primary" type="button" (click)="this.addItem()">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>New {{'Product' | tenantWords}}
      </button>
      <button mat-button color="primary" type="button" (click)="this.addLot()">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>New {{'Lot' | tenantWords}}
      </button>
    </div>
  </ng-template>

  <ng-template #productField>
    <mat-form-field [appearance]="this.fieldAppearance">
      <mat-label>{{"Product" | tenantWords}}</mat-label>
      <mat-select id="itemSelect" required [(ngModel)]="this.itemId" name="itemSelect"
        (ngModelChange)="itemSelectionChanged()">
        <mat-option>
          <ngx-mat-select-search [(ngModel)]="this.searchItem" (ngModelChange)="filterItems()"
            placeholderLabel="Find product." noEntriesFoundLabel="No products found" name="itemSearch">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngIf="this.filteredItemOptions.length === 0">
          {{this.itemSearchPrompt}}
        </mat-option>
        <mat-option *ngFor="let item of this.filteredItemOptions" [value]="item.id">
          {{item.name}} {{(item.varietyName ? "(" + item.varietyName + ")" : "")}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>

  <ng-template #lotField>
    <mat-form-field [appearance]="this.fieldAppearance">
      <mat-label>{{"Lot" | tenantWords}}</mat-label>
      <mat-select id="lotSelect" required [(ngModel)]="this.lotId" name="lotSelect"
        (ngModelChange)="lotSelectionChanged()">
        <mat-option>
          <ngx-mat-select-search [(ngModel)]="this.searchLot" (ngModelChange)="filterLots()"
            placeholderLabel="Find lot." noEntriesFoundLabel="No lots found" name="lotSearch">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngIf="this.filteredLotOptions.length === 0">
          {{this.lotSearchPrompt}}
        </mat-option>
        <mat-option *ngFor="let lot of this.filteredLotOptions" [value]="lot.id">
          {{lot.lotNumber}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>

  <ng-template #qtyFields>
    <mat-form-field *ngIf="!this.selectedItem?.packageHasComponents" [appearance]="this.fieldAppearance">
      <mat-label>Qty</mat-label>
      <input [(ngModel)]="this.qty" matInput type="number" id="pickCommentsInput" name="pickCommentsInput"
        (change)="readyCheck()" (input)="readyCheck()">
      <button *ngIf="this.qty" matSuffix mat-icon-button aria-label="Clear" type="button"
        (click)="this.qty = 0; this.readyCheck()">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </mat-form-field>

    <ng-container *ngIf="this.selectedItem?.packageHasComponents">
      <mat-form-field [appearance]="this.fieldAppearance">
        <mat-label>{{this.selectedItem.packageUnitOfMeasure | titlecase}} Qty</mat-label>
        <input [(ngModel)]="this.packageQty" matInput type="number" id="packageQtyInput" name="packageQtyInput"
          (change)="setQty()" (input)="setQty()">
        <button *ngIf="this.packageQty" matSuffix mat-icon-button aria-label="Clear" type="button"
          (click)="this.packageQty = 0; this.setQty()">
          <fa-icon [icon]="faXmark"></fa-icon>
        </button>
      </mat-form-field>

      <mat-form-field [appearance]="this.fieldAppearance">
        <mat-label>{{this.selectedItem.packageComponentName | titlecase}} Qty</mat-label>
        <input [(ngModel)]="this.packageComponentQty" matInput type="number" id="componentQtyInput"
          name="componentQtyInput" (change)="setQty()" (input)="setQty()">
        <button *ngIf="this.packageComponentQty" matSuffix mat-icon-button aria-label="Clear" type="button"
          (click)="this.packageComponentQty = 0; this.setQty()">
          <fa-icon [icon]="faXmark"></fa-icon>
        </button>
      </mat-form-field>

      <mat-form-field [appearance]="this.fieldAppearance">
        <mat-label>Description</mat-label>
        <input [(ngModel)]="this.productDescription" matInput type="text" id="productDescription"
          name="productDescription" (change)="setDescription()" (input)="setDescription()">
        <button *ngIf="this.productDescription" matSuffix mat-icon-button aria-label="Clear" type="button"
          (click)="this.productDescription = ''; this.setDescription()">
          <fa-icon [icon]="faXmark"></fa-icon>
        </button>
      </mat-form-field>
    </ng-container>
  </ng-template>

  <ng-template #qtySummary>
    <div class="qty-summary" *ngIf="this.showSummary">
      <span class="chip" *ngIf="this.selectedItem.packageHasComponents">
        {{this.selectedItem.packageUnitOfMeasure}} Qty <b>{{this.qty | number}}</b>
      </span>
      <span class="chip" *ngIf="this.selectedItem.packageQuantityPerPallet > 1">
        Est. Pallets <b>{{this.getPalletQty() | number}}</b>
      </span>
      <span class="chip" *ngIf="this.selectedItem.packageComponentWeight != 0">
        Total Weight ({{this.selectedItem.packageComponentWeightUnitOfMeasure}}) <b>{{this.getWeight() | number}}</b>
      </span>
    </div>
  </ng-template>

</form>
